import { Component, OnInit, SecurityContext } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmService } from '../../shared/germplasm/service/germplasm.service';
import { GermplasmDetailsContext } from '../germplasm-details.context';
import { GermplasmStudy } from '../../shared/germplasm/model/germplasm.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParamContext } from '../../shared/service/param.context';
import { GRAPHICAL_QUERIES_URL, INVENTORY_DETAILS_URL } from '../../app.constants';
import { UrlService } from '../../shared/service/url.service';
import { StudyService } from '../../shared/study/service/study.service';
import { AlertService } from '../../shared/alert/alert.service';
import { Principal } from '../../shared';
import { Program } from '../../shared/program/model/program';
import { GermplasmDetailsPopupService } from '../germplasm-details-popup.service';

@Component({
    selector: 'jhi-observations-pane',
    templateUrl: './observations-pane.component.html'
})
export class ObservationsPaneComponent implements OnInit {

    user: any;
    studies: GermplasmStudy[] = [];
    graphicalQueryUrl: SafeResourceUrl;

    constructor(public languageservice: JhiLanguageService,
                public translateService: TranslateService,
                public urlService: UrlService,
                private germplasmService: GermplasmService,
                public germplasmDetailsContext: GermplasmDetailsContext,
                private paramContext: ParamContext,
                private sanitizer: DomSanitizer,
                private studyService: StudyService,
                private alertService: AlertService,
                private principal: Principal,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService) {

        const queryParams = '?cropName=' + this.paramContext.cropName
            + '&programUUID=' + this.paramContext.programUUID
            + '&loggedInUserId=' + this.paramContext.loggedInUserId
            + '&selectedProjectId=' + this.paramContext.selectedProjectId
            + '&gid=' + this.germplasmDetailsContext.gid;

        const urlStr = this.urlService.buildSafeUrl(GRAPHICAL_QUERIES_URL + queryParams);
        // Fall back to a blank page if the URL is not on the allowlist.
        this.graphicalQueryUrl = urlStr !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(urlStr)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    async ngOnInit() {
        this.germplasmService.getGermplasmStudiesByGid(this.germplasmDetailsContext.gid).toPromise().then((value) => {
            this.studies = value;
        });
        this.user = await this.principal.identity();
    }

    isClickable(study: GermplasmStudy) {
        return this.paramContext.programUUID === study.programUUID;
    }

    async openStudy(studyId: any) {

        const studyDetailsResponse = await this.studyService.getStudyDetails(studyId).toPromise();
        const studyDetails = studyDetailsResponse.body;

        if (this.urlService.isStudyNotUserAccessible(studyDetails.id, studyDetails.name, studyDetails.locked, studyDetails.ownerId, this.user)) {
            this.alertService.error('study.manager.errors.study-locked', { param: studyDetails.createdByName });
        } else {
            if (this.germplasmDetailsPopupService) {
                this.germplasmDetailsPopupService.close();
            }
            const program = new Program();
            program.crop = this.paramContext.cropName;
            program.id = String(this.paramContext.selectedProjectId);
            program.uniqueID = this.paramContext.programUUID;
            this.urlService.openStudy(studyDetails.id, studyDetails.name, program);
        }
    }
}
